import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

const styles = ({ spacing }: Theme) =>
  createStyles({
    gridContainer: {
      height: 752,
      marginTop: '32px',
    },
    toursContainer: {
      maxHeight: 784,
      height: 784,
      overflowY: 'auto',
    },
    toolbar: {
      minHeight: 'auto',
      marginBottom: spacing(4),
    },
    showPolylineButton: {
      marginLeft: spacing(2),
      display: 'flex',
      justifyContent: 'flex-end',
      transition: 'width 1s',
    },
  })

export default makeStyles(styles)
